import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useBreakpoint from '@/composables/useBreakpoint'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SaleBanner',
  setup(__props) {

  const { sale } = useIcons()
  const { isMobileDevice } = useBreakpoint()

  const saleBannerTitle = computed(() => process.env.VUE_APP_SALE_BANNER_TITLE)

  const saleBannerDescription = computed(() => process.env.VUE_APP_SALE_BANNER_DESCRIPTION)

  const bannerBackgroundColor = computed(() => {
    const envValue = process.env.VUE_APP_SALE_BANNER_BACKGROUND_COLOR_CODE
    return envValue ? `#${envValue}` : '#080d22'
  })

  const bannerColor = computed(() => {
    const envValue = process.env.VUE_APP_SALE_BANNER_FOREGROUND_COLOR_CODE
    return envValue ? `#${envValue}` : '#ffffff'
  })

  const saleTitleAndDescription = computed(() => `${saleBannerTitle.value}: <b>${saleBannerDescription.value}</b>`)

return { __sfc: true,sale, isMobileDevice, saleBannerTitle, saleBannerDescription, bannerBackgroundColor, bannerColor, saleTitleAndDescription, computed, useIcons, SVGRenderer, useBreakpoint }
}

})